(function () {
  function initWhenReady() {
    if (!window.Alpine) return false;

    if (!window.__videoBlockWithControlsRegistered) {
      window.__videoBlockWithControlsRegistered = true;

      window.Alpine.data("videoBlockWithControls", () => ({
        hasStarted: false,

        handleVideoClick(e) {
          if (this.hasStarted) return;

          this.play();
        },

        play() {
          const video = this.$refs.video;
          if (!video) return;

          this.hasStarted = true;

          const p = video.play();
          if (p && typeof p.catch === "function") {
            p.catch(() => {
              this.hasStarted = false;
            });
          }
        },

        onEnded() {
          const video = this.$refs.video;
          if (video) video.currentTime = 0;
        }
      }));
    }

    window.ProductNew = function ({
      product,
      variant,
      featuredMediaID,
      template,
      thumbnailsPosition,
      showThumbnailsOnMobile
    }) {
      return {
        productRoot: null,
        product,
        currentVariant: variant,
        currentMediaId: featuredMediaID,
        loading: false,
        quantity: "1",
        options: [],
        optionHandles: [],
        addedToCart: false,
        stickyAddToCartShown: false,
        variantChanged: false,
        template,
        thumbnailsPosition,
        showThumbnailsOnMobile,
        hasGiftCardRecipientForm: false,
        cartAddErrorMessage: null,
        isMaxLgBreakpoint: window.isMaxLgBreakpoint ? window.isMaxLgBreakpoint() : false,
        maxLgBreakpointMQL: window.maxLgBreakpointMQL ? window.maxLgBreakpointMQL() : null,
        mainAddToCartWasInView: false,
        mainAddToCartInView: false,
        hasScrolledPastMainAddToCart: false,
        lastSubmitterEl: null,

        get addToCartText() {
          if (this.currentVariant) {
            if (this.currentVariant.available) {
              if (this.template === "product.preorder") return window.theme?.strings?.preOrder;
              return window.theme?.strings?.addToCart;
            }
            if (!this.currentVariant.available) return window.theme?.strings?.soldOut;
          }
          return window.theme?.strings?.unavailable;
        },

        get currentVariantId() {
          return this.currentVariant ? this.currentVariant.id : null;
        },

        get currentVariantAvailable() {
          return this.currentVariant ? this.currentVariant.available : null;
        },

        get currentVariantTitle() {
          if (this.currentVariant && this.currentVariant.title && !this.currentVariant.title.includes("Default")) {
            return this.currentVariant.title;
          }
          return "";
        },

        get currentPrice() {
          return this.currentVariant?.price;
        },

        get isUsingSlideshowToDisplayMedia() {
          const splideEl = this.productRoot?.querySelector(".splide--product");
          if (window.Splide && this.productRoot && splideEl) {
            if (window.slideshows && window.slideshows[`${splideEl.id}`] && !window.slideshows[`${splideEl.id}`].state.is(window.Splide.STATES.DESTROYED)) {
              return true;
            }
          }
          return false;
        },

        get currentVariantHasCompareAtPrice() {
          return this.currentVariant && this.product?.compare_at_price_max && this.currentVariant.compare_at_price > this.currentVariant.price;
        },

        variantFromOptions(options = this.options) {
          return this.product.variants.find((v) =>
            v.options.every((value, index) => value === options[index])
          ) || null;
        },

        getVariantById(id) {
          return this.product.variants.find((v) => v.id === id) || null;
        },

        formatMoney(price) {
          return window.formatMoney ? window.formatMoney(price, window.theme?.moneyFormat) : price;
        },

        init() {
          this.productRoot = this.$root;

          const targetBtn = this.$refs.mainAddToCartBtn;

          this.stickyAddToCartShown = false;
          this.hasScrolledPastMainAddToCart = false;

          if (targetBtn && "IntersectionObserver" in window) {
            const io = new IntersectionObserver(
              (entries) => {
                const entry = entries[0];

                if (entry.isIntersecting) {
                  this.stickyAddToCartShown = false;
                  return;
                }

                const isAboveViewport = entry.boundingClientRect.top < 0;

                if (isAboveViewport) {
                  this.hasScrolledPastMainAddToCart = true;
                }

                this.stickyAddToCartShown = this.hasScrolledPastMainAddToCart && isAboveViewport;
              },
              { root: null, threshold: 0 }
            );

            io.observe(targetBtn);
          }

          window.addEventListener("shapes:request-add-to-cart", (e) => {
            const form = this.$refs.productForm;
            if (!form) return;

            this.lastSubmitterEl = e?.detail?.submitter || null;

            (form.requestSubmit) ? form.requestSubmit() : form.submit();
          });

          if (this.maxLgBreakpointMQL && this.maxLgBreakpointMQL.matches !== undefined) {
            this.isMaxLgBreakpoint = this.maxLgBreakpointMQL.matches;
            this.maxLgBreakpointMQL.addEventListener("change", (e) => {
              this.isMaxLgBreakpoint = e.matches;
            });
          }

          if (this.$root.querySelector('[x-data="GiftCardRecipient"]')) {
            this.hasGiftCardRecipientForm = true;
          }

          if (this.$refs.productForm) {
            this.$refs.productForm.addEventListener("submit", this.submitForm.bind(this));
          }

          this.getOptions();

          this.$watch("currentMediaId", (value, oldValue) => {
            if (showThumbnailsOnMobile) {
              this.$root.dispatchEvent(new CustomEvent("shapes:product:mediachange", {
                bubbles: true,
                detail: {
                  mediaId: this.currentMediaId,
                  slideshowId: this.productRoot.querySelector(".splide--product")?.id
                }
              }));
            }
            if (this.isUsingSlideshowToDisplayMedia) return;

            const oldEl = this.$root.querySelector(`[data-product-single-media-wrapper="${oldValue}"]`);
            const newEl = this.$root.querySelector(`[data-product-single-media-wrapper="${value}"]`);

            if (oldEl) oldEl.dispatchEvent(new CustomEvent("mediaHidden"));
            if (newEl) newEl.dispatchEvent(new CustomEvent("mediaVisible"));
          });

          this.$watch("currentVariant", (value, oldValue) => {
            document.dispatchEvent(new CustomEvent("theme:variant:change", {
              detail: {
                productRootEl: this.productRoot,
                formEl: this.productRoot.querySelector("form.shopify-product-form"),
                variant: value,
                previousVariant: oldValue,
                product: this.product
              }
            }));
          });

          this.productRoot.addEventListener("theme:change:variant", (event) => {
            if (!event.detail || !event.detail.variantId) {
              console.error("theme:change:variant requires a variant ID");
              return;
            }
            const v = this.getVariantById(event.detail.variantId);
            if (!v) {
              console.error("theme:change:variant: variant not found");
              return;
            }

            const allPositions = Array.from({ length: this.product.options.length }, (_, i) => i);
            for (const position of allPositions) {
              this.productRoot.querySelectorAll(`[data-single-option-selector][data-position="${position + 1}"]`)
                .forEach((optionEl) => {
                  if (optionEl.tagName === "SELECT") {
                    optionEl.value = v.options[position];
                  } else {
                    optionEl.checked = optionEl.value === v.options[position];
                  }
                  optionEl.dispatchEvent(new Event("change"));
                });
            }
          });

          this.$watch("stickyAddToCartShown", (value) => {
            if (value) {
              this.updateStickyBarHeight();
            } else {
              document.body.style.setProperty(
                "--sticky-add-to-cart-height",
                "0px"
              );
            }
          });

          this._onResizeStickyBar = () => {
            if (this.stickyAddToCartShown) {
              this.updateStickyBarHeight();
            }
          };

          window.addEventListener("resize", this._onResizeStickyBar);
        },

        updateStickyBarHeight() {
          const bar = this.$refs.stickyBar;

          if (!bar || !this.stickyAddToCartShown) {
            document.body.style.setProperty(
              "--sticky-add-to-cart-height",
              "0px"
            );
            return;
          }

          this.$nextTick(() => {
            const height = bar.offsetHeight || 0;
            document.body.style.setProperty(
              "--sticky-add-to-cart-height",
              `${height}px`
            );
          });
        },

        optionChange() {
          this.getOptions();
          const matchedVariant = this.variantFromOptions(this.options);
          this.currentVariant = matchedVariant;

          if (this.currentVariant) {
            if (window.variantLiveRegion) window.variantLiveRegion(this.currentVariant);

            if (this.currentVariant.featured_media) {
              this.currentMediaId = this.currentVariant.featured_media.id;
            }

            if (window.currentURLWithParams) {
              const url = window.currentURLWithParams([["variant", this.currentVariantId]]).toString();
              window.history.replaceState({ path: url }, "", url);
            }

            if (this.$refs.singleVariantSelector) {
              this.$refs.singleVariantSelector.dispatchEvent(new Event("change", { bubbles: true }));
            }

            this.$root.dispatchEvent(new CustomEvent("shapes:product:variantchange", {
              bubbles: true,
              detail: { variant: this.currentVariant }
            }));
          }

          this.variantChanged = true;
        },

        getOptions() {
          this.options = [];
          this.optionHandles = [];

          const selectors = this.$root.querySelectorAll("[data-single-option-selector]");
          selectors.forEach((selector) => {
            if (selector.nodeName === "SELECT") {
              const value = selector.value;
              this.options.push(value);
              this.optionHandles.push(selector.options[selector.selectedIndex]?.dataset?.handle);
            } else {
              if (selector.checked) {
                const value = selector.value;
                this.options.push(value);
                this.optionHandles.push(selector.dataset.handle);
              }
            }
          });
        },

        changeMedia(direction) {
          this.$root.dispatchEvent(new CustomEvent("shapes:product:arrow-change", {
            bubbles: true,
            detail: { direction }
          }));

          if (this.thumbnailsPosition == "under") {
            const currentThumbnail = this.$root.querySelector(".product-thumbnail-list-item--active");
            const nextElement = direction == "prev"
              ? currentThumbnail?.previousElementSibling
              : currentThumbnail?.nextElementSibling;

            if (nextElement) {
              nextElement.querySelector(".media-thumbnail")?.click();
            }
          }
        },

        submitForm(evt) {
          evt.preventDefault();
          this.loading = true;
          this.addedToCart = false;
          const submitButton = evt.submitter || this.lastSubmitterEl;

          this.lastSubmitterEl = null;

          if (submitButton) {
            submitButton.classList.add("is-loading");
          }

          const formData = new FormData(this.$refs.productForm);
          const formId = this.$refs.productForm.getAttribute("id");
          const modalCart = window.theme?.settings?.cartType === "modal";

          const config = window.fetchConfigDefaults
            ? window.fetchConfigDefaults("application/javascript")
            : { method: "POST", headers: {} };

          if (modalCart) {
            formData.append("sections", "cart-items-new,cart-footer-new,cart-item-count");
            formData.append("sections_url", window.location.pathname);
          }

          config.body = formData;
          config.headers = config.headers || {};
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          fetch(`${window.theme?.routes?.cart_add_url || "/cart/add.js"}`, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status) {
                this.loading = false;
                if (submitButton) {
                  submitButton.classList.remove("is-loading");
                }
                const errors = data.errors || data.description;
                const message = data.description || data.message;

                if (!this.hasGiftCardRecipientForm) {
                  this.cartAddErrorMessage = message || window.theme?.strings?.cartError;

                  this.$nextTick(() => {
                    const el = this.$refs?.cartAddErrorMessageEl;
                    if (!el) return;

                    const rect = el.getBoundingClientRect();
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

                    const isVisible =
                      rect.top < viewportHeight &&
                      rect.bottom > 0;

                    if (!isVisible) {
                      el.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                      });
                    }
                  });
                }

                const errorDetail = {
                  sourceId: formId,
                  variantId: Number(formData.get("id")),
                  errors,
                  message
                };

                document.body.dispatchEvent(new CustomEvent("shapes:cart:adderror", {
                  detail: { source: "product-form", ...errorDetail }
                }));

                document.dispatchEvent(new CustomEvent("theme:product:error:add-to-cart", {
                  detail: {
                    productRootEl: window.Alpine?.raw ? window.Alpine.raw(this.productRoot) : this.productRoot,
                    formEl: window.Alpine?.raw ? window.Alpine.raw(this.$refs.productForm) : this.$refs.productForm,
                    ...errorDetail
                  }
                }));
                return;
              }

              this.loading = false;
              if (submitButton) {
                submitButton.classList.remove("is-loading");
              }
              this.cartAddErrorMessage = null;
              this.addedToCart = true;

              window.dispatchEvent(
                new CustomEvent("shapes:cart:added", {
                  detail: { formId }
                })
              );

              if (modalCart) {
                document.body.dispatchEvent(new CustomEvent("shapes:cart:afteradditem", {
                  bubbles: true,
                  detail: { response: data, sourceId: formId }
                }));
              }

              if (!document.querySelector('[data-show-on-add="true"]')) {
                if (this.$refs.added) this.$nextTick(() => this.$refs.added.focus());
              }
            })
            .catch(console.error);
        },

        openZoom(id) {
          const imageZoomDataEl = this.productRoot.querySelector("[data-photoswipe-images]");
          if (!imageZoomDataEl) return;

          const imageZoomData = JSON.parse(imageZoomDataEl.innerHTML);
          const imageMediaIDsArray = Object.keys(imageZoomData);
          const index = imageMediaIDsArray.indexOf(id);

          this.$refs.photoSwipeComponent?.dispatchEvent(new CustomEvent("shapes:photoswipe:open", {
            detail: { index }
          }));
        }
      };
    };

    return true;
  }

  if (!initWhenReady()) {
    document.addEventListener("alpine:init", initWhenReady, { once: true });
  }
})();
